<template>
  <div class="UpiInfoPop">
    <div class="cardBorder">
      <div class="card">
        <div class="title">{{ $t('lang.UPIandBankCardInfo.bankTransferInfo') }}</div>
        <div class="formBox">
          <div class="item">
            <div class="label">
              <div class="leftLabel">{{ $t('lang.UPIandBankCardInfo.Bankcode') }}</div>
              <div class="rightLabel" @click="openLink()">{{ $t('lang.UPIandBankCardInfo.FindIFSC') }}</div>
            </div>
            <input v-model="value" @focus="inputFocus" @blur="inputBlur" class="input" :placeholder="$t('lang.UPIandBankCardInfo.bankTransferInfoPlaceholder')" type="text">
            <div class="historyListBox" :style="{'maxHeight':isShowHistoryBox?'30.555vw':'0vw'}">
              <div @click="setValue(item)" :class="value===item?'listItemActive':'listItem'" v-for="(item, index) in historyList" :key="index">{{item}}</div>
            </div>
            <div class="tip">{{ $t('lang.UPIandBankCardInfo.IFSCInvalid') }}</div>
          </div>
          <div class="submit">{{ $t('lang.UPIandBankCardInfo.submit') }}</div>
        </div>
        <img @click="close" src="../../assets/images/accountInfo/close.png" alt="" class="close">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
      FindIFSCLink: 'https://bankifsccode.com/',
      isShowHistoryBox: false,
      value: '',
      historyList: ['Mahesh Bhonde@paytm', 'yourname@bankname', 'yournameyournameyourname@bankname']
    }
  },
  methods: {
    openLink () {
      window.open(this.FindIFSCLink)
    },
    setValue (item) {
      this.value = item
    },
    close () {
      this.value = ''
      this.$emit('close')
    },
    inputFocus () {
      this.isShowHistoryBox = true
    },
    inputBlur () {
      this.isShowHistoryBox = false
    }
  }
}
</script>

<style lang="less" scoped>
.UpiInfoPop{
  height: 100vh;
  width: 100vw;
  background-color: rgba(0,0,0,0.6);
  //background-color: red;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
  display: flex;
  justify-content: center;
  align-items: center;
  .cardBorder{
    background-color: rgb(115,115,115);
    width: 86.666vw;
    height: 65.555vw;
    border-radius: 4.166vw;
    padding: 0.2vw;
    position: relative;
    animation: scaleUp 0.2s ease-out;
    @keyframes scaleUp {
      from {
        transform: scale(0);
        opacity: 0;
      }
      to {
        transform: scale(1);
        opacity: 1;
      }
    }
    .card{
      background-color: rgb(26,27,26);
      border-radius: 4.166vw;
      height: 100%;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 4.8vw 6.72vw;
      gap: 6vw;

      .close{
        height: 4.733vw;
        width: 4.333vw;
        position: absolute;
        top: 69vw;
      }
      .title{
        font-size: 5.833vw;
        font-weight: bold;
        color: #fff;
      }
      .formBox{
        width: 74.886vw;
        height: 9.444vw;
        display: flex;
        flex-direction: column;
        gap: 6vw;
        .item{
          display: flex;
          flex-direction: column;
          gap: 2.777vw;
          .label{
            color: #F0D4A6;
            font-size: 4.166vw;
            display: flex;
            justify-content: space-between;
            .leftLabel{}
            .rightLabel{
              color: #0575C5;
              font-size: 3.611vw;
              border-bottom: 1px solid;
            }
          }
          .input{
            height: 9.44vw;
            width: 74.886vw;
            border-radius: 0.8333vw;
            padding: 3.413vw;
            border: 1px solid rgb(134,120,96);
            color: #FFFFFF;
            font-size: 3.472vw;
          }
          input::placeholder{
            color: #404040;
            font-size: 3.472vw;
          }
          .historyListBox{
            width: 74.886vw;
            position: absolute;
            background-color: #0E0F0E;
            display: flex;
            flex-direction: column;
            top: 30.7vw;
            font-size: 3.33vw;
            color: #828282;
            overflow: hidden;
            overflow-y: scroll;
            transition: all 0.17s linear;
            .listItem{
              height: 8.313vw;
              padding: 2.58vw 2.361vw;
              display: flex;
              align-items: center;
            }
            .listItemActive{
              height: 8.313vw;
              padding: 2.58vw 2.361vw;
              display: flex;
              align-items: center;
              background-color: rgb(59,59,59);
              color: #CACACA;
            }
          }
          .tip{
            color: #B20000;
            font-size: 3.472vw;
          }
        }
        .submit{
          height: 9.444vw;
          width: 74.886vw;
          background: linear-gradient(to right, #EFD6AD 0%, #DAB67C 100%);
          border-radius: 1.388vw;
          color: #000000;
          font-weight: bold;
          font-size: 4.1666vw;
          text-align: center;
          line-height: 9.444vw;
        }
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/BankTransferInfoPop/index.vue